import { useEffect } from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';

import { trackRedirection } from 'actions/tracker/tracker';
import type { RootState } from 'reducers/types';
import { getOrderCallToAction } from 'selectors';

type RedirectToReturnCTAProps = ConnectedProps<typeof connector>;

export const RedirectToReturnCTAComponent = ({
  returnCTA,
  trackRedirection,
}: RedirectToReturnCTAProps) => {
  const { url } = returnCTA;

  useEffect(() => {
    if (url) {
      window.location.assign(url);
      trackRedirection();
    }
  });

  return null;
};

const mapStateToProps = (state: RootState) => ({
  returnCTA: getOrderCallToAction(state),
});

const mapDispatchToProps = {
  trackRedirection,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
const RedirectToReturnCTA = connector(RedirectToReturnCTAComponent);

export { RedirectToReturnCTA };
